module.exports = __webpack_public_path__ + "img/材料力学1_6_6.6f6787b6.jpg";